import { Box } from '@mui/material';
import ExoAvatar from './ExoAvatar';

const ExoTableRecipient = ({ row, key = 'recipient' }) => {
  const recipient = row[key];

  return (
    <Box className="flex flex-row gap-2 justify-start sm:justify-start items-center w-full">
      {row.recipientType === 'company' && (
        <ExoAvatar
          picture={recipient.logo && recipient.logo.thumbnailUrl}
          name={recipient.name}
          size="35px"
          type="company"
        />
      )}
      {row.recipientType === 'contact' && (
        <ExoAvatar
          name={recipient.firstName + ' ' + recipient.lastName}
          size="35px"
          colorPoolId={recipient.colorPoolId}
        />
      )}
      <Box className="hidden md:block">
        {row.recipientType === 'contact' &&
          (recipient?.firstName || '') + ' ' + (recipient?.lastName || '')}
        {row.recipientType === 'company' && recipient.name}
      </Box>
    </Box>
  );
};

export default ExoTableRecipient;
